import type React from 'react';
import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';
import { PRE_OCCUPANCY_AGREEMENT } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const INITIAL_STATE = {
  [PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.IS_ENABLED]: false,
  [PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.PROJECT_DESCRIPTION]: '',
};

export default function PreOccupancyAgreement({ section, setSectionValues }: Props): JSX.Element {
  function onNoAgreedWork(): void {
    setSectionValues(INITIAL_STATE);
  }

  function onYesAgreedWork(): void {
    setSectionValues({
      [PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onProjectDescription(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({ [PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.PROJECT_DESCRIPTION]: value });
  }

  return (
    <FormField
      required
      label={<Label>Have you agreed to do any work on the property before the tenant moves in?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onYesAgreedWork}
          noHandler={onNoAgreedWork}
          yesActive={section.getFieldValue(PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.IS_ENABLED)}
        >
          <FormField
            required
            label={<Label id="project-description">Describe the projects to be done</Label>}
            control={
              <Textarea
                aria-labelledby="project-description"
                onChange={onProjectDescription}
                value={section.getFieldValue(PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.PROJECT_DESCRIPTION)}
                css={{ resize: 'vertical' }}
                maxLength={2000}
              />
            }
            description={<FormHelp>Limited to 2,000 characters</FormHelp>}
          />
        </YesAndNoExpansion>
      }
    />
  );
}
